// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"fY-z","subtitle":"gY-z","wrapper":"hY-z","leftArrow":"iY-z","rightArrow":"jY-z"};